(function () {
  if (!window.autoAddSample || !window.autoAddSample.variantId) return;

  var SAMPLE_VARIANT_ID = window.autoAddSample.variantId;
  var DISMISS_KEY = 'pouffSampleDismissed';
  var AUTO_KEY = 'pouffSampleAutoAdded';
  var isBusy = false;
  var sampleWasPresent = !!window.autoAddSample.sampleInCartInitially;

  function isDismissed() {
    return sessionStorage.getItem(DISMISS_KEY) === '1';
  }

  function setDismissed(value) {
    if (value) {
      sessionStorage.setItem(DISMISS_KEY, '1');
    } else {
      sessionStorage.removeItem(DISMISS_KEY);
    }
  }

  function getCartElement() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  // Every cart mutation (add-to-cart, quick-add, quantity change) reports a
  // differently-shaped payload, so re-fetch the cart itself as the single
  // source of truth rather than trusting each event's cartData shape.
  function postCart(url, body) {
    var cartElement = getCartElement();
    if (cartElement && typeof cartElement.getSectionsToRender === 'function') {
      body.sections = cartElement.getSectionsToRender().map(function (section) {
        return section.id;
      });
      body.sections_url = window.location.pathname;
    }

    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        var updatedCartElement = getCartElement();
        if (updatedCartElement && typeof updatedCartElement.renderContents === 'function' && body.sections) {
          updatedCartElement.renderContents(response);
        }
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'auto-add-sample', cartData: response });
        return response;
      });
  }

  function addSample() {
    postCart(window.routes.cart_add_url, { id: SAMPLE_VARIANT_ID, quantity: 1 })
      .then(function () {
        sessionStorage.setItem(AUTO_KEY, '1');
        sampleWasPresent = true;
      })
      .catch(function (e) {
        console.error('auto-add-sample:', e);
      })
      .finally(function () {
        isBusy = false;
      });
  }

  function removeSample() {
    postCart(window.routes.cart_change_url, { id: SAMPLE_VARIANT_ID, quantity: 0 })
      .then(function () {
        sessionStorage.removeItem(AUTO_KEY);
        sampleWasPresent = false;
      })
      .catch(function (e) {
        console.error('auto-add-sample:', e);
      })
      .finally(function () {
        isBusy = false;
      });
  }

  function handleCartState(cart) {
    var sampleItem = cart.items.find(function (item) {
      return item.variant_id === SAMPLE_VARIANT_ID;
    });
    var otherItemsQty = cart.items.reduce(function (sum, item) {
      return item.variant_id === SAMPLE_VARIANT_ID ? sum : sum + item.quantity;
    }, 0);
    var sampleIsPresent = !!sampleItem;
    var sampleQty = sampleItem ? sampleItem.quantity : 0;

    // Customer changed the sample's quantity by hand: treat it as a real
    // purchase from here on, not a freebie we're tracking.
    if (sampleIsPresent && sampleQty !== 1 && sessionStorage.getItem(AUTO_KEY) === '1') {
      sessionStorage.removeItem(AUTO_KEY);
    }

    if (otherItemsQty === 0) {
      setDismissed(false);
      if (sampleIsPresent && sampleQty === 1 && sessionStorage.getItem(AUTO_KEY) === '1') {
        removeSample();
        return;
      }
      sampleWasPresent = sampleIsPresent;
      isBusy = false;
      return;
    }

    if (sampleWasPresent && !sampleIsPresent) {
      setDismissed(true);
      sessionStorage.removeItem(AUTO_KEY);
      sampleWasPresent = false;
      isBusy = false;
      return;
    }

    if (!sampleIsPresent && !isDismissed()) {
      addSample();
      return;
    }

    sampleWasPresent = sampleIsPresent;
    isBusy = false;
  }

  subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
    if (isBusy || event.source === 'auto-add-sample') return;
    isBusy = true;

    fetch('/cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(handleCartState)
      .catch(function (e) {
        console.error('auto-add-sample:', e);
        isBusy = false;
      });
  });
})();